import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import CustomLink from '../CustomLink';
import { SubscriptionCard } from '../SubscriptionCard';
import { MONTHLY_WITHOUT_TRIAL_PLAN, MONTHLY_WITH_PAID_TRIAL_PLAN, QUARTERLY_WITHOUT_TRIAL_PLAN, MONTHLY_3999_WITHOUT_TRIAL_PLAN, MONTHLY_3999_WITH_MONTH_2999_TRIAL_PLAN, MONTHLY_3999_WITH_1999_TRIAL_PLAN, QUARTERLY_7999_WITHOUT_TRIAL_PLAN, QUARTERLY_7999_WITH_QUARTER_5999_TRIAL_PLAN, WEEKLY_999_WITHOUT_TRIAL_PLAN, WEEKLY_999_WITH_WEEK_750_TRIAL_PLAN, WEEKLY_499_WITHOUT_TRIAL_PLAN, WEEKLY_499_WITH_WEEK_349_TRIAL_PLAN, WEEKLY_499_WITH_WEEK_375_TRIAL_PLAN, MONTHLY_1999_WITHOUT_TRIAL_PLAN, MONTHLY_1999_WITH_MONTH_1399_TRIAL_PLAN, MONTHLY_1999_WITH_MONTH_1499_TRIAL_PLAN, QUARTERLY_3999_WITHOUT_TRIAL_PLAN, QUARTERLY_3999_WITH_QUARTER_2999_TRIAL_PLAN, QUARTERLY_3999_WITH_QUARTER_2799_TRIAL_PLAN } from '../../../lib/shared/subscription-plans';
import styles from './SubscriptionPlanSelector.css';
import { Icon } from '../Icon';

const cx = classnames.bind(styles);

const SUBSCRIPTION_TERMS_LINK = 'https://futureproof.app/terms-and-conditions.html#h_01HTQC5P4757CM5KV86DDG92PZ ';

function SubscriptionPlanSelector({className, plans, onSubmit, defaultPlan, isPending}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });
    const [selectedSubcriptionData, selectSubscription] = useState(plans.find(({plan}) => plan === defaultPlan) || {});

    const renderAgreementTermsText = ({price, trialPrice, billingPeriod}) => (
        <p className={styles.agreementTermsText}>
            By clicking "Get my plan", you agree to automatic subscription renewal. First {billingPeriod} is {trialPrice || price}, then {price}/{billingPeriod}. Learn more about cancellation and refund policy in
            {' '}
            <CustomLink
                to={SUBSCRIPTION_TERMS_LINK}
                target='_blank'
            >
                Subscription terms
            </CustomLink>
            {'.'}                    
        </p>
    );

    const renderAgreementTerms = () => {
        if (selectedSubcriptionData.plan === WEEKLY_999_WITHOUT_TRIAL_PLAN || selectedSubcriptionData.plan === WEEKLY_499_WITHOUT_TRIAL_PLAN || selectedSubcriptionData.plan === WEEKLY_499_WITH_WEEK_349_TRIAL_PLAN || selectedSubcriptionData.plan === WEEKLY_499_WITH_WEEK_375_TRIAL_PLAN || selectedSubcriptionData.plan === WEEKLY_499_WITH_WEEK_375_TRIAL_PLAN) {
            return renderAgreementTermsText({billingPeriod: 'week', price: selectedSubcriptionData.price, trialPrice: selectedSubcriptionData.trial?.price})
        };
    
        if (selectedSubcriptionData.plan === MONTHLY_3999_WITHOUT_TRIAL_PLAN || selectedSubcriptionData.plan === MONTHLY_3999_WITH_MONTH_2999_TRIAL_PLAN || selectedSubcriptionData.plan === MONTHLY_1999_WITHOUT_TRIAL_PLAN || selectedSubcriptionData.plan === MONTHLY_1999_WITH_MONTH_1399_TRIAL_PLAN || selectedSubcriptionData.plan === MONTHLY_1999_WITH_MONTH_1499_TRIAL_PLAN) {
            return renderAgreementTermsText({billingPeriod: 'month', price: selectedSubcriptionData.price, trialPrice: selectedSubcriptionData.trial?.price})
        };

        if (selectedSubcriptionData.plan === QUARTERLY_7999_WITHOUT_TRIAL_PLAN || selectedSubcriptionData.plan === QUARTERLY_7999_WITH_QUARTER_5999_TRIAL_PLAN || selectedSubcriptionData.plan === QUARTERLY_3999_WITHOUT_TRIAL_PLAN || selectedSubcriptionData.plan === QUARTERLY_3999_WITH_QUARTER_2999_TRIAL_PLAN || selectedSubcriptionData.plan === QUARTERLY_3999_WITH_QUARTER_2799_TRIAL_PLAN) {
            return renderAgreementTermsText({billingPeriod: '3-month', price: selectedSubcriptionData.price, trialPrice: selectedSubcriptionData.trial?.price})
        };

        if (selectedSubcriptionData.plan === MONTHLY_3999_WITH_1999_TRIAL_PLAN) {
            return (
                <p className={styles.agreementTermsText}>
                    By clicking "Get my plan", you agree to automatic subscription renewal. First 7 days is $19.99, then {selectedSubcriptionData.price}/month. Learn more about cancellation and refund policy in
                    {' '}
                    <CustomLink
                        to={SUBSCRIPTION_TERMS_LINK}
                        target='_blank'
                    >
                        Subscription terms
                    </CustomLink>
                    {'.'}                    
                </p>
            )
        };
    };

    return (
        <div className={classes}>
            <div className={styles.plans}>
                {plans.map(plan => (
                    <SubscriptionCard
                        subscriptionData={plan}
                        selectedSubcriptionData={selectedSubcriptionData}
                        selectSubscription={selectSubscription}
                        key={plan.plan}
                    />
                ))}
            </div>
            {renderAgreementTerms()}
            <Button
                label='get my plan'
                onClick={() => onSubmit(selectedSubcriptionData)}
                className={styles.button}
                isLoading={isPending}
            />
            <div className={styles.safeBlock}>
                <Icon name='safe' />
                <span>30-day money back guarantee</span>
            </div>
        </div>
    )
};

SubscriptionPlanSelector.propTypes = {
    className: PropTypes.string,
    plans: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    defaultPlan: PropTypes.string,
    isPending: PropTypes.bool
};

SubscriptionPlanSelector.defaultProps = {
    className: '',
    isPending: false
};

export {
    SubscriptionPlanSelector
};
